import { createFileRoute } from '@tanstack/react-router'
import { PostShiftReviewPage } from '@/features/scheduler/pages/post-shift-review'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/post-shift-review'
)({
  component: PostShiftReviewPage,
})
